@if (profileField$ | async; as profileField) {
  <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
    <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
  </dt>
  @if (translatedValue$ | async; as translatedValue) {
    <ng-container
            *ngTemplateOutlet="
                canSearchOnClick(profileField.FieldDefinition) ? searchableData : nonSearchableData;
                context: { translatedValue: translatedValue, fieldDefinition: profileField.FieldDefinition }
            "
      >
    </ng-container>
  } @else {
    <dd class="sh-description-list__details">-</dd>
  }
}

<ng-template #searchableData let-translatedValue="translatedValue" let-fieldDefinition="fieldDefinition">
  <dd
    [routerLink]="searchRouterLink"
    [queryParams]="getSearchRouterParams(fieldDefinition, translatedValue.value)"
    class="sh-link sh-description-list__details"
    >
    {{ translatedValue.label }}
  </dd>
</ng-template>

<ng-template #nonSearchableData let-translatedValue="translatedValue">
  <dd class="sh-description-list__details">{{ translatedValue.label }}</dd>
</ng-template>

